import { IGeoLocation, IImage } from 'src/common-types/index';

export interface IRoomsContent {
  amenities: string[];
  descriptions: string[];
  images: string[];
  roomKey: string;
}

export interface IHotelInfo {
  hotelDetails: IHotelDetails;
  packages: IPackage[];
  roomsContent: IRoomsContent[];
  trustYouData: ITrustYouData;
  adjustedPackageGroups: IAdjustedPackageGroup[];
}

export interface IAdjustedPackageGroup {
  groupedPackages: IPackage[];
}

export interface IHotelDetails {
  address: string;
  amenities: IAmenities[];
  amenityDescriptions: string[];
  checkInInformation: string[];
  checkOutInformation: string[];
  descriptions: string[];
  additionalDescriptions: string[];
  otherImportantInformation: string[];
  email: string;
  id: number;
  images: IImage[];
  location: IGeoLocation;
  locationDescriptions: string[];
  pets: string[];
  phone: number;
  roomsCount: number;
  starRating: number;
  title: string;
  city: string;
  countryCode: string;
  zipCode: string;
  state: string;
}

export interface IAmenities {
  amenityId: number;
  categoryName: string;
  name: string;
}

export interface IPackage {
  hotelId: number;
  packageId: string;
  price: number;
  refundability: RefundableEnum;
  refundableUntil: string;
  rooms: IPackageRoom[];
  priceDifference: number;
  cancellationPolicyText?: string;
  refundabilityText?: string;
  pricePerNight: number;
}

export interface IPackageRoom {
  adultsCount: number;
  availability: string;
  bedType: string;
  id: string;
  kidsAges: number[];
  roomBasis: string;
  roomName: string;
  specialDeals: string[];
  targetRoomKey: string;
}

export interface ITrustYouData {
  id: string;
}

/*eslint-disable */
export enum RefundableEnum {
  Unknown = 'unknown',
  Refundable = 'refundable',
  Nonrefundable = 'nonrefundable',
}
/*eslint-enable */
